var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-indicator-units',{staticClass:"monitoring-indicator-units"})
}
var staticRenderFns = []

export { render, staticRenderFns }